import { render, staticRenderFns } from "./sideTitle.vue?vue&type=template&id=5dc97fea&scoped=true&"
import script from "./sideTitle.vue?vue&type=script&lang=js&"
export * from "./sideTitle.vue?vue&type=script&lang=js&"
import style0 from "./sideTitle.vue?vue&type=style&index=0&id=5dc97fea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc97fea",
  null
  
)

export default component.exports